import { render } from "./CopyText.vue?vue&type=template&id=67465389&scoped=true"
import script from "./CopyText.vue?vue&type=script&lang=js"
export * from "./CopyText.vue?vue&type=script&lang=js"

import "./CopyText.vue?vue&type=style&index=0&id=67465389&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67465389"]])

export default __exports__